const React = require("react")
const { Info } = require("./info")

module.exports = {
  Info: (props) => <Info {...props} />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/toast/index.js